
import { getContext } from ".";

export const setScene = (name: string) => {
    const ctx = getContext();

    const scene = ctx.scenes.find(item => item.name === name);

    if (!scene) return
    // Génération du CharacterConfig
    ctx.updateSceneCtx({
        id: `scene_${scene.id}`,
        width: 400,  // On garde la taille actuelle de la scène
        height: 400,
        background: {
            image: scene.img,
            mode: 'cover',
        },
    });

};